var InternalEventType;
(function (InternalEventType) {
  InternalEventType["INTERNAL_DOWNLOAD_AS_EVENT"] = "internalDownloadAsEvent";
  InternalEventType["INTERNAL_DROPDOWN_VALUE_SELECTED_EVENT"] = "internalDropdownValueSelectedEvent";
  InternalEventType["INTERNAL_NOTIFICATION_MESSAGE_EVENT"] = "internalNotificationMessageEvent";
  InternalEventType["INTERNAL_SHOW_RESOURCE_COPY_LINK_DIALOG_EVENT"] = "internalShowResourceCopyLinkDialogEvent";
  InternalEventType["INTERNAL_SHOW_SAVED_QUERIES_EVENT"] = "internalShowSavedQueriesEvent";
  InternalEventType["INTERNAL_SHARE_QUERY_EVENT"] = "internalShareQueryEvent";
  InternalEventType["INTERNAL_EXPLAIN_QUERY_EVENT"] = "internalExplainQueryEvent";
  InternalEventType["INTERNAL_YASQE_DROPDOWN_ACTION_SELECTED_EVENT"] = "internalYasqeDropdownActionSelected";
  InternalEventType["INTERNAL_CREATE_SAVED_QUERY_EVENT"] = "internalCreateSavedQueryEvent";
  InternalEventType["INTERNAL_QUERY_EXECUTED"] = "internalQueryExecuted";
  InternalEventType["INTERNAL_QUERY_EVENT"] = "internalQueryEvent";
  InternalEventType["INTERNAL_COUNT_QUERY_EVENT"] = "internalCountQueryEvent";
  InternalEventType["INTERNAL_COUNT_QUERY_RESPONSE_EVENT"] = "internalCountQueryResponseEvent";
  InternalEventType["INTERNAL_REQUEST_ABORTED_EVENT"] = "internalRequestAbortedEvent";
  InternalEventType["INTERNAL_KEYBOARD_SHORTCUTS_CLICKED_EVENT"] = "internalKeyboardShortcutsClickedEvent";
})(InternalEventType || (InternalEventType = {}));

export { InternalEventType as I };
